import { getMicrositeBase, sanitizeHTML } from '../components/shared/utils/common-utils'
import { appMenuNames } from './constants'
/*
 *  Email validation
 */
export const isValidEmail = email => {
  const emailFormatted = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailFormatted.test(email)
}

/*
 *  Zipcode validation
 */
export const isValidZipcode = zip => {
  const zipFormatted = /(^\d{5}$)|(^\d{5}-\d{4}$)/
  return zipFormatted.test(zip)
}

/* Utility function to format phone numbers */
export const formatPhoneNumber = input => {
  let formattedInput = ''
  const receivedInput = input.toString()
  if (receivedInput) {
    formattedInput = receivedInput
      .replace(/\D+/g, '')
      .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
  }
  return formattedInput
}

export const formatPhoneNumberForAriaLabel = tel => {
  let label = ''
  if (tel) {
    // Remove `tel:` protocol, insert spaces between the numbers
    tel = tel.split('tel:')[1].split('').join(' ')
    // Group the numbers, insert periods
    label = `${tel.slice(0, 5)}.${tel.slice(5, 11)}.${tel.slice(11)}`
  }
  return label
}

/**
 * Helper function to simply code
 * See https://www.freecodecamp.org/news/pipe-and-compose-in-javascript-5b04004ac937/
 * @param  {...any} fns functions that will be run in order.
 * @returns function that should be called. Just pass as an arg the variable you want to run the fns on
 */
export const pipe =
  (...fns) =>
  x => {
    return fns.reduce((v, f) => f(v), x)
  }

export const wrapAnalyticsImagesInDiv = () => {
  const baseUrl = 'https://insight.adsrvr.org/track'
  const imgTags = document.querySelectorAll('img[src*="' + baseUrl + '"]')
  imgTags.forEach(imgTag => {
    if (!imgTag.closest('div')) {
      const divTag = document.createElement('div')
      divTag.style.height = '1px'
      divTag.style.overflow = 'hidden'
      divTag.appendChild(sanitizeHTML(imgTag.cloneNode(true)))
      imgTag.parentNode.replaceChild(divTag, imgTag)
    }
  })
}

export const recursiveSearchMenuItemsURL = (menuItems, searchPage, pageStack) => {
  if (!menuItems.length) {
    return
  }
  for (let i = 0; i < menuItems.length; i++) {
    if (
      menuItems[i].HstMenuItemRepresentation.url.includes(searchPage) &&
      menuItems[i].HstMenuItemRepresentation.url.length - searchPage.length ===
        menuItems[i].HstMenuItemRepresentation.url.indexOf(searchPage)
    ) {
      return {
        currentPage: menuItems[i].HstMenuItemRepresentation.name,
        currentPageParams: menuItems[i].HstMenuItemRepresentation.parameters,
        breadCrumbs: pageStack,
      }
    }
    if (menuItems[i].HstMenuItemRepresentation.menuItems.length) {
      pageStack.push({
        pageName: menuItems[i].HstMenuItemRepresentation.name,
        pageURL: menuItems[i].HstMenuItemRepresentation.url,
        pageParameters: menuItems[i].HstMenuItemRepresentation.parameters,
      })
      const result = recursiveSearchMenuItemsURL(
        menuItems[i].HstMenuItemRepresentation.menuItems,
        searchPage,
        pageStack
      )
      if (result) return result
    }
  }
  pageStack.pop()
}

export const getBreadCrumbs = menuItems => {
  if (menuItems.length) {
    const currentPagePath = window.location.pathname
    const pageStack = []

    return recursiveSearchMenuItemsURL(menuItems, currentPagePath, pageStack)
  }
}

export const getMenuBasedOnURL = () => {
  let foundMenu = false
  const url = getMicrositeBase()
  appMenuNames.forEach((value, key) => {
    if (url.search(key) !== -1) {
      foundMenu = value
    }
  })
  return foundMenu
}
